import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import smoothscroll from 'smoothscroll-polyfill'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { IconArrowDown } from '@components/atoms/icons'
import RolexClock from '@components/rolex-clock'
import { CtaArrow } from '@components/atoms'
import MatchPlayStatusBar from '@components/match-play-status-bar'
import useStyles, { Hero, Logo, SummaryBox } from './match-play-header.styles'

const MatchPlayHeader = (props) => {
  const {
    heroImage,
    logo,
    scores,
    showExternalAd,
    fullLeaderboard,
    slug,
    leaderboardRef,
    isEmbedView,
    updatedAt,
    startDate,
    endDate,
  } = props
  const styles = useStyles({ fullLeaderboard })

  useEffect(() => {
    smoothscroll.polyfill()
  }, [])

  const handleButtonClick = () => leaderboardRef.current.scrollIntoView({ behavior: 'smooth' })

  const CtaButton = ({ showFullLeaderboard }) => {
    return showFullLeaderboard ? (
      <Button
        className={styles.moreInfo}
        onClick={handleButtonClick}
      >
        View Daily Matches
        <IconArrowDown className={styles.arrowDown} />
      </Button>
    ) : (
      <Button
        className={styles.moreInfo}
        href={`events/leaderboards/${slug}`}
      >
        View Leaderboard
        <CtaArrow className={styles.cta} />
      </Button>
    )
  }

  return (
    <Hero
      image={heroImage && heroImage.url}
      fullleaderboard={fullLeaderboard ? 1 : 0}
      embedview={isEmbedView ? 1 : 0}
    >
      <Box className={styles.adWrapper}>
        <RolexClock showExternalAd={showExternalAd} />
      </Box>
      {isEmbedView && (
        <Box className={styles.statusWrapper}>
          <MatchPlayStatusBar
            updatedAt={updatedAt}
            startDate={startDate}
            endDate={endDate}
          />
        </Box>
      )}
      {!isEmbedView && <Logo image={logo && logo.url} fullleaderboard={fullLeaderboard ? 1 : 0} />}
      <SummaryBox
        fullleaderboard={fullLeaderboard ? 1 : 0}
        embedview={isEmbedView ? 1 : 0}
      >
        <Box className={styles.country}>
          <Typography variant="h5" gutterBottom>USA</Typography>
          <Typography variant="h2">{scores[0]?.teamPointsTotal || '0'}</Typography>
        </Box>
        <Box className={styles.country}>
          <Typography variant="h5" gutterBottom>EUROPE</Typography>
          <Typography variant="h2">{scores[1]?.teamPointsTotal || '0'}</Typography>
        </Box>
      </SummaryBox>
      {!isEmbedView && <CtaButton showFullLeaderboard={fullLeaderboard} />}
      <Box className={isEmbedView ? styles.adWrapper : ''}>
        <RolexClock showExternalAd={showExternalAd} isMobile />
      </Box>
    </Hero>
  )
}

MatchPlayHeader.propTypes = {
  heroImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  logo: PropTypes.shape({
    url: PropTypes.string,
  }),
  scores: PropTypes.array,
  showExternalAd: PropTypes.bool,
  fullLeaderboard: PropTypes.bool,
  isEmbedView: PropTypes.bool,
  slug: PropTypes.string,
  leaderboardRef: PropTypes.object,
  updatedAt: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
}

export default MatchPlayHeader
